import { Outlet } from 'react-router-dom';
import { BottomNav } from '../ui/AppShell';
import LiveFeedbackToast from '../live/LiveFeedbackToast';
import useRenderMode from '../../hooks/useRenderMode';

/**
 * Thin layout for the nested /dashboard/* routes.
 *
 * - Phone mode: keep BottomNav + LiveFeedbackToast (compact dashboard, no rail).
 * - Desk / wall mode: hide BottomNav (top-strip nav lives in each page) and
 *   the toast (the persistent live rail in the page handles new feedback).
 */
const DashboardLayout = () => {
  const mode = useRenderMode();
  const isPhone = mode === 'phone';
  return (
    <div className="app-bg" style={{ minHeight: '100dvh' }}>
      <Outlet />
      {isPhone && <BottomNav />}
      {isPhone && <LiveFeedbackToast />}
    </div>
  );
};

export default DashboardLayout;
